import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, Platform, View } from 'react-native';
import { Image } from 'expo-image';
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
export const SkeletonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.skeleton,
    style: {
        container: {},
        animation: {
            height: '100%',
            width: '100%',
            backgroundColor: '#DEE6E9',
        },
        content: {
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        image: {
            maxWidth: 80,
            maxHeight: 80,
            height: '100%',
            width: '100%'
        }
    }
})(({ style, containerStyle, visible, hideLogo, assets }) => {
    var _a, _b, _c, _d;
    const [isVisible, setIsVisible] = useState(false);
    const [hasImage, setHasImage] = useState(false);
    const opacity = useRef(new Animated.Value(0.6)).current;
    const imageOpacity = useRef(new Animated.Value(1)).current;
    const handleLayout = useCallback((e) => {
        var _a, _b;
        const height = e.nativeEvent.layout.height || 0;
        const width = e.nativeEvent.layout.width || 0;
        const maxHeight = ((_a = style === null || style === void 0 ? void 0 : style.image) === null || _a === void 0 ? void 0 : _a.maxHeight) || 0;
        const maxWidth = ((_b = style === null || style === void 0 ? void 0 : style.image) === null || _b === void 0 ? void 0 : _b.maxWidth) || 0;
        setHasImage(height >= maxHeight && width >= maxWidth);
    }, []);
    useEffect(() => {
        let isCleaned = false;
        opacity.stopAnimation();
        imageOpacity.stopAnimation();
        if (visible) {
            setIsVisible(true);
            Animated.timing(imageOpacity, {
                toValue: 1,
                duration: 100,
                useNativeDriver: Platform.OS !== 'web'
            }).start();
            const fadeInAndOut = Animated.sequence([
                Animated.timing(opacity, {
                    toValue: 0.6,
                    duration: 600,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(opacity, {
                    toValue: 1,
                    duration: 600,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(opacity, {
                    toValue: 0.6,
                    duration: 600,
                    useNativeDriver: Platform.OS !== 'web'
                }),
            ]);
            Animated.loop(fadeInAndOut).start();
            return;
        }
        Animated.timing(opacity, {
            toValue: 0,
            duration: 600,
            useNativeDriver: Platform.OS !== 'web'
        }).start(() => {
            !isCleaned && setIsVisible(false);
        });
        Animated.timing(imageOpacity, {
            toValue: 0,
            duration: 600,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
        return () => {
            isCleaned = true;
        };
    }, [visible]);
    if (!isVisible) {
        return null;
    }
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyle], children: [_jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.animation, { opacity }] }), !hideLogo && (_jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.content, { opacity: imageOpacity }], onLayout: handleLayout, children: hasImage && (!!((_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.home_logo_url) || !!((_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.logo_url)) && (_jsx(Image, { source: (((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.home_logo_url) || ((_d = assets === null || assets === void 0 ? void 0 : assets.images) === null || _d === void 0 ? void 0 : _d.logo_url)), style: style === null || style === void 0 ? void 0 : style.image, contentFit: 'contain' })) }))] }));
});
